import React, { useState, useContext } from "react";
import { Checkbox, DefaultButton, PrimaryButton } from "@fluentui/react";
import { t } from "i18next";
import ModalHeader from "../Modal/ModalHeader";
import ModalMain from "../Modal/ModalMain";
import ModalFooter from "../Modal/ModalFooter";
import themeContext from "../../context/theme/ThemeContext";

const MultiSessionWarningModal = ({ hideModal, description }) => {
  const { getThemeColor } = useContext(themeContext);
  const [doNotShowAgain, setDoNotShowAgain] = useState(false);

  const handleGoToActiveSessions = () => {
    if (doNotShowAgain) {
      // OLD: localStorage.setItem("hideMultiSessionWarning", "true");
      sessionStorage.setItem("hideMultiSessionWarning", "true");
    }
    hideModal();
    window.location.href = "/user/account-and-settings?tab=active-logins";
  };

  const handleCancel = () => {
    if (doNotShowAgain) {
      // OLD: localStorage.setItem("hideMultiSessionWarning", "true");
      sessionStorage.setItem("hideMultiSessionWarning", "true");
    }
    hideModal();
  };

  const DefaultButtonList = [
    {
      title: t("active-sessions.ok-continue"),
      onclick: handleCancel,
    },
  ];

  const PrimaryButtonList = [
    {
      title: t("active-sessions.go-to-active-sessions"),
      onclick: handleGoToActiveSessions,
    },
  ];

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={t("active-sessions.multiple-sessions-heading")}
        handleCancel={hideModal}
      />
    ),
    body: (
      <div
        className="global-modal-body"
        style={{
          color: getThemeColor("primary-color"),
          fontSize: "15px",
          marginBottom: "0px",
        }}
      >
        {description}
      </div>
    ),
    footer: (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "right",
          background: getThemeColor("modal-header-footer"),
          padding: "10px 16px",
          borderRadius: "0 0 10px 10px",
          flexWrap: "wrap", // ensures it doesn't overflow on smaller screens
          gap: "8px",
        }}
      >
        {/* Left: Checkbox (takes only required width) */}
        {/* <div style={{ display: "flex", alignItems: "center" }}>
          <Checkbox
            label={t("active-sessions.do-not-show-again")}
            checked={doNotShowAgain}
            onChange={(_, checked) => setDoNotShowAgain(checked)}
            styles={{
              root: { margin: 0, padding: 0 },
              label: {
                color: getThemeColor("primary-color"),
                fontSize: "13px",
              },
            }}
          />
        </div> */}

        {/* Right: Buttons */}
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <DefaultButton
            text={t("active-sessions.ok-continue")}
            onClick={handleCancel}
            styles={{
              root: {
                height: "32px",
                lineHeight: "32px",
                padding: "0 12px",
              },
            }}
          />
          <PrimaryButton
            text={t("active-sessions.go-to-active-sessions")}
            onClick={handleGoToActiveSessions}
            styles={{
              root: {
                height: "32px",
                lineHeight: "32px",
                padding: "0 14px",
                whiteSpace: "nowrap", // ✅ prevents button text wrapping
              },
            }}
          />
        </div>
      </div>
    ),

    width: "520px",
  };

  return (
    <ModalMain
      updatedModal={true}
      modalDetails={modalDetails}
      showModal={true}
    />
  );
};

export default MultiSessionWarningModal;
